/*--------------
V 1.0.0 - Criado por Larner Diogo

DESCIÇÃO:
Componente para rotas não autenticadas


COMPONENTS
***********************************************************/
import { Component } from '@angular/core';

@Component({
  selector: 'app-no-authorization',
  templateUrl: './index.html'
})
export class NoAuthorizationComponent { }



// WEBPACK FOOTER //
// ./src/app/no-authorization/index.ts